'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}let

DistributionParameters=function(){
function DistributionParameters(binSize,firstBinStart,lastBinStart){_classCallCheck(this,DistributionParameters);
this._binSize=binSize;
this._firstBinStart=firstBinStart;
this._lastBinStart=lastBinStart;
}DistributionParameters.prototype.

















checkDistributionsConformity=function checkDistributionsConformity(distribution){
if(distribution.binSize!==this._binSize){
throw new Error('Bin size mismatch');
}

if(distribution.start!==this._firstBinStart){
throw new Error('Distribution start mismatch');
}

if(distribution.bins.length!==this.totalBins){
throw new Error('Distribution end mismatch');
}
};_createClass(DistributionParameters,[{key:'binSize',get:function(){return this._binSize}},{key:'firstBinStart',get:function(){return this._firstBinStart}},{key:'lastBinStart',get:function(){return this._lastBinStart}},{key:'totalBins',get:function(){return(this._lastBinStart-this._firstBinStart)/this._binSize+1}}],[{key:'DefaultFatigueDistributionParameters',get:function()

{
return DefaultFatigueDistributionParameters;
}}]);return DistributionParameters}();


const DefaultFatigueDistributionParameters=new DistributionParameters(1,3,20);

module.exports=DistributionParameters;
//# sourceMappingURL=distributionParameters.js.map
